import { render } from "./BasicTextArea.vue?vue&type=template&id=51e487a5&scoped=true"
import script from "./BasicTextArea.vue?vue&type=script&lang=js"
export * from "./BasicTextArea.vue?vue&type=script&lang=js"

import "./BasicTextArea.vue?vue&type=style&index=0&id=51e487a5&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e487a5"]])

export default __exports__